__webpack_require__.p = "https://bs.fast.ax/build/betpawa-demo/1768487237/";